import { StyleSheet } from "react-native";
import { inset } from "../../../../utils/helpers/css";

export const rankModalStyles = StyleSheet.create({
  tabs: {
    height: 34,
    flexDirection: "row",
    position: "absolute",
    top: -36,
    left: 11,
    right: 48,
  },
  tabsWrapper: {
    width: 500,
    justifyContent: "center",
    flexDirection: "row",
    position: "relative",
    height: "100%",
  },
  touchableOpacity: {
    position: "absolute",
    top: 0,
  },
  tabImage: {
    height: 62,
  },
  tabTextWrapper: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    height: 34,
  },
  flatList: {
    paddingTop: 20,
    width: 620,
    maxWidth: "100%",
  },
});

export const singleRankStyles = StyleSheet.create({
  container: {
    width: "100%",
    flexDirection: "row",
    position: "relative",
    marginVertical: 5,
    overflow: "visible",
    paddingLeft: 8,
    flex: 1,
  },
  backgroundWrapper: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
  },
  background: {
    height: "100%",
  },
  rankLogo: {
    position: "absolute",
    left: 0,
    right: 0,
  },
  fullAbsoluteInset: {
    position: "absolute",
    ...inset(0),
  },
  text: {
    color: "white",
    fontWeight: "900",
  },
  chipExpContainer: { gap: 6, paddingHorizontal: 10 },
});
